module.exports = __webpack_public_path__ + "images/30b50e4ce8aa77d8ab23d6b119c86ca2.png";